import { render, staticRenderFns } from "./SurveySays.vue?vue&type=template&id=8b286338&"
import script from "./SurveySays.vue?vue&type=script&lang=js&"
export * from "./SurveySays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports